
ChangeLogItemController = (ChangeLogService, $element, $scope) ->
    'ngInject'

    $scope.$program = @program

    $element.toggleClass('draft', not @item.is_published)
    $element.toggleClass('published', @item.is_published)
    @templateUrl = ChangeLogService.templateUrl(@item)

    return

ChangeLogItemComponent =
    controller: ChangeLogItemController
    controllerAs: 'changeLogItem'
    templateUrl: 'changeLog/item'
    bindings: item: '=', program: '=?'


module.component 'changeLogItem', ChangeLogItemComponent
